import { useEffect, useState } from "react";
import {
  MAX_PRODUCTS,
  MAX_USERS,
  checkProductLimit,
  checkUserLimit,
  isLimited,
} from "../../utils/planLimits";

/*
 * Shows how much of the plan is used ("Utilisateurs : 3 / 5") and warns once
 * the limit is reached. kind = "users" | "products". Renders nothing when the
 * limit is disabled or the count cannot be read.
 */
const PlanLimitBanner = ({ kind, refreshKey }) => {
  const [state, setState] = useState(null);
  const max = kind === "users" ? MAX_USERS : MAX_PRODUCTS;
  const label = kind === "users" ? "Utilisateurs" : "Produits";

  useEffect(() => {
    if (!isLimited(max)) return;
    let cancelled = false;
    const check = kind === "users" ? checkUserLimit : checkProductLimit;
    check(1).then((result) => {
      if (!cancelled && result.count !== null) {
        setState(result);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [kind, max, refreshKey]);

  if (!state) return null;
  const reached = state.count >= max;
  return (
    <div className={`alert ${reached ? "alert-warning" : "alert-light border"} py-2 mb-3`}>
      <strong>
        {label} : {state.count} / {max}
      </strong>
      {reached && (
        <span className="ml-2">
          Limite de votre abonnement atteinte. Contactez-nous pour l'augmenter.
        </span>
      )}
    </div>
  );
};

export default PlanLimitBanner;
